import { useLayoutEffect, useRef } from 'react';

import { useAppSelector } from '../../../../common/hooks/useThunkDispatch';
import { userProfileSelectors } from '../../../../common/selectors/userProfileSelectors';

export const useEpiEditButtonRepositioning = () => {
    const hasBeenRepositioned = useRef<boolean>(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const isEpiUser = useAppSelector(userProfileSelectors.isEpiUser);

    useLayoutEffect(() => {
        if (!isEpiUser || hasBeenRepositioned.current) return;

        const observer = new MutationObserver(() => {
            const element = document.querySelector('#epi-quickNavigator');
            if (element) {
                handleElementFound(element);
                observer.disconnect();
            }
        });

        const handleElementFound = (element: Element) => {
            const targetNode = containerRef.current;

            if (element && targetNode) {
                const clonedNode = element.cloneNode(true) as HTMLUListElement;

                clonedNode.style.position = 'static';
                targetNode.style.top = `var(--headerStickyBannerHeight)`;

                targetNode.appendChild(clonedNode);
                element.remove();
                hasBeenRepositioned.current = true;
            }
        };

        observer.observe(document, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
        };
    }, [isEpiUser]);

    return containerRef;
};
